var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69492 6.2C6.83598 5.799 7.11441 5.46086 7.48089 5.24548C7.84737 5.0301 8.27826 4.95136 8.69722 5.02323C9.11619 5.09509 9.49621 5.31291 9.76996 5.63812C10.0437 5.96332 10.1936 6.37491 10.1929 6.8C10.1929 8 8.39292 8.6 8.39292 8.6M8.44092 11H8.44692M14.4409 8C14.4409 11.3137 11.7546 14 8.44092 14C5.12721 14 2.44092 11.3137 2.44092 8C2.44092 4.68629 5.12721 2 8.44092 2C11.7546 2 14.4409 4.68629 14.4409 8Z",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.ad576c1a1e47881110cfbe90635f3996.svg";
export { ForwardRef as ReactComponent };